import ProductsGrid from './products-grid';
export default ProductsGrid;